import React from 'react';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import css from './CancellationNotice.css';

const CancellationNotice = ({ subscription, isProvider = false }) => {
  const deliveryType = subscription?.attributes?.deliveryType;
  const isHomeDelivery = deliveryType === 'home';

  const providerAttributes = subscription?.deliveryToProvider?.attributes;
  const storeName = providerAttributes?.name || '';
  const storeAddress =
    providerAttributes?.businessLocation?.selectedPlace?.address ||
    providerAttributes?.businessLocation?.search ||
    '';

  return (
    <div className={css.cancellationNoticeBox}>
      <div className={css.cancellationHeader}>
        <h4 className={css.cancellationTitle}>
          <FormattedMessage
            id={isProvider ? 'CancellationNotice.providerTitle' : 'CancellationNotice.title'}
            defaultValue={isProvider ? 'Procedura zwrotu po anulowaniu' : 'Instrukcja zwrotu sprzętu'}
          />
        </h4>
      </div>

      <div className={css.cancellationBody}>
        {isProvider ? (
          // === Widok z perspektywy sklepu / partnera ===
          <p className={css.cancellationText}>
            {isHomeDelivery ? (
              <FormattedMessage
                id="CancellationNotice.providerHomeInstruction"
                defaultValue="Klient zwróci sprzęt bezpośrednio przesyłką kurierską FEDEX do magazynu centralnego. Nie musisz przyjmować tego zwrotu w sklepie stacjonarnym."
              />
            ) : (
              <FormattedMessage
                id="CancellationNotice.providerStoreInstruction"
                defaultValue="Klient jest zobowiązany do osobistego zwrotu sprzętu do Twojego sklepu stacjonarnego. Po przyjęciu i weryfikacji stanu urządzenia oznacz zamówienie jako odebrane/zakończone w panelu."
              />
            )}
          </p>
        ) : (
          // === Widok z perspektywy klienta ===
          isHomeDelivery ? (
            <p className={css.cancellationText}>
              <FormattedMessage
                id="CancellationNotice.homeInstruction"
                defaultValue="Sprzęt został dostarczony kurierem. Aby dokończyć anulowanie, zapakuj bezpiecznie urządzenie i odeślij je kurierem FEDEX na adres magazynu zwrotów. Zwrot w sklepie stacjonarnym nie jest możliwy."
              />
            </p>
          ) : (
            <p className={css.cancellationText}>
              <FormattedMessage
                id="CancellationNotice.storeInstruction"
                defaultValue="Zwróć sprzęt do sklepu {store}, w którym został odebrany {storeAddressInfo}."
                values={{
                  store: storeName ? <strong>{storeName}</strong> : '',
                  storeAddressInfo: storeAddress ? (
                    <span>({storeAddress})</span>
                  ) : (
                    ''
                  ),
                }}
              />
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default injectIntl(CancellationNotice);